import routes from '@/modules/balance/routes'
import store from '@/modules/balance/store'

export default { routes, store }
